import { Gusset, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties/StringProperty';

export const GussetSchema = new ModelSchema<Gusset>('gusset', {
  category: ModelCategory.ComponentDesignData,

  displayName: (gusset) => gusset.material,

  children: {},

  properties: {
    material: StringProperty,
  },
});
